import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  Box,
  DashPlaceholder,
  Flex,
  Text,
  Button,
  Image,
} from 'dash-ui';

import { GetPropertyByIdQuery } from 'gql/generated.graphql';
import { RoutesPath } from 'flow-components/routes/routes';
import { stickyTopBarStyles } from 'containers/properties/helpers/stickyTopBarStyles';

const HeaderWrapper = styled(Box)<{ top?: number }>`
  ${stickyTopBarStyles}
  z-index: 5;
`;

interface IProps {
  property: GetPropertyByIdQuery['getPropertyById'];
}

function PropertyDetailsHeader({ property }: IProps) {
  const { t: tLabels } = useTranslation('common', {
    keyPrefix: 'labels',
  });
  // @ts-ignore
  const { _id: propertyId, name, mainPropertyMediaFile } = property;
  const file = mainPropertyMediaFile?.files[0];

  return (
    <HeaderWrapper p={4} w="100%" pos="sticky" top={90}>
      <Flex flexDirection="row" alignItems="center">
        {file ? (
          <Image
            src={file.thumbnailFile?.publicUrl || ''}
            size={92}
            fit="contain"
          />
        ) : (
          <DashPlaceholder size={80} borderRadius={4} />
        )}

        <Flex flexDirection="column" flex={1} w="100%" ml={3}>
          <Flex flexDirection="column">
            <Text xl bold>
              {name}
            </Text>
          </Flex>
          <Flex flexDirection="row" mt={2}>
            <Button
              mr={3}
              medium
              onClick={() => {
                window?.open(
                  RoutesPath.PropertyPreview.replace(':id', propertyId),
                  '_blank'
                );
              }}
            >{tLabels`preview`}</Button>
          </Flex>
        </Flex>
      </Flex>
    </HeaderWrapper>
  );
}

export default PropertyDetailsHeader;
